import {
  isLessonConsultationOnly,
  LESSON_PRICE_DISPLAY_LABEL,
} from "@/lib/config/lessonBooking";

interface MonthlyLessonLike {
  pricePerSession?: number;
  monthlyOptions?: Array<{ sessions: number; discount: number }>;
}

interface LessonPriceLike extends MonthlyLessonLike {
  type?: string;
  priceNegotiable?: boolean;
  price?: number | null;
}

/** 월 정기 레슨 기본 옵션(첫 번째) 기준 월 총액 */
export function getMonthlyLessonTotalKrw(lesson: MonthlyLessonLike): number | null {
  if (!lesson.pricePerSession || lesson.pricePerSession <= 0) return null;
  const option = lesson.monthlyOptions?.[0];
  const sessions = option?.sessions ?? 4;
  const discount = option?.discount ?? 0;
  return Math.round(lesson.pricePerSession * sessions * (1 - discount / 100));
}

export function formatLessonPriceLabel(lesson: LessonPriceLike): string {
  if (isLessonConsultationOnly()) return LESSON_PRICE_DISPLAY_LABEL;
  if (lesson.priceNegotiable) return "가격 협의";
  if (lesson.type === "monthly") {
    const monthlyTotal = getMonthlyLessonTotalKrw(lesson);
    if (monthlyTotal) return `${monthlyTotal.toLocaleString()}원/월`;
  }
  if (typeof lesson.price === "number" && lesson.price > 0) {
    return `${lesson.price.toLocaleString()}원`;
  }
  if (typeof lesson.pricePerSession === "number" && lesson.pricePerSession > 0) {
    return `${lesson.pricePerSession.toLocaleString()}원/회`;
  }
  return "가격 확인";
}

export const YANG_TAEWOOK_LESSON_TYPES = [
  {
    id: "single",
    name: "1회 체험 레슨",
    type: "single" as const,
    duration: 60,
    price: 50_000,
    description: "첫 방문·실력 점검용 1회 체험 레슨입니다.",
  },
  {
    id: "monthly",
    name: "월 정기 레슨",
    type: "monthly" as const,
    duration: 60,
    pricePerSession: 50_000,
    description: "월 정기 레슨입니다. 주 1회(4회/월) 기준입니다.",
    monthlyOptions: [
      { sessions: 4, discount: 0, label: "주 1회 (4회/월)" },
      { sessions: 8, discount: 0, label: "주 2회 (8회/월)" },
      { sessions: 12, discount: 0, label: "주 3회 (12회/월)" },
    ],
  },
];
